module.exports = __webpack_public_path__ + "static/media/partner-preview.788dff84.png";